import { extend } from 'lodash'
import update from 'immutability-helper'
import { successMessage } from '~/services/messager'
import { v4 as uuidv4 } from 'uuid'

const formatWorkflowSteps = (workflowSteps) => {
	const workflowStepsList = []
	for (const key in workflowSteps) {
		workflowStepsList.push(workflowSteps[key])
	}
	return workflowStepsList
}

export const selectEdit = (data, payload) => {
	let form = payload.form

	const pageVariables = form.map((page) => page.fields.map(getVariable))

	form.forEach((page) => {
		page.ids = page.fields.map(() => uuidv4())
		page.valid = page.fields.map(() => true)
	})

	let new_config = payload.config
	new_config['templateType'] = payload.text_type

	const temp = extend(data, {
		id: payload.id,
		title: payload.name,
		form: form,
		text: payload.textfile,
		team_id: payload.team_id,
		workflow: extend(payload.workflow, {
			steps: formatWorkflowSteps(payload.workflow.steps),
		}),
		signers: payload.signers,
		variables: pageVariables,
		config: new_config,
		ckeditorCss: payload.ckeditor_css,
		ckeditorStyles: payload.ckeditor_styles,
	})
	return temp
}

const getVariable = (field) => {
	let variable
	if (field.structure) {
		let structure
		if (Array.isArray(field.structure)) {
			structure = field.structure.map((f) => f.variable)
		} else {
			structure = [field.structure.variable]
		}

		variable = {
			...field.variable,
			structure: structure,
		}
	} else if (field.fields) {
		variable = getSubfieldVariables(field)
	} else {
		variable = field.variable
	}

	return variable
}

const getSubfieldVariables = (field) => {
	let fields = []
	if (Array.isArray(field.fields)) {
		fields = field.fields.map((f) => f.toUpperCase())
	}

	if (
		field?.variable?.type === 'person' &&
		Array.isArray(field?.person_type) &&
		field.person_type.length > 1
	) {
		fields.push('PERSON_TYPE')
	}

	return {
		fields: fields,
		...field.variable,
	}
}

export const selectForm = (form, payload) => {
	if (payload.name === 'title') {
		const newForm = update(form, {
			[payload.pageIndex]: { title: { $set: payload.value } },
		})
		return newForm
	} else if (payload.name === 'field') {
		successMessage({
			content: 'Campo salvo com sucesso.',
		})
		return update(form, {
			[payload.pageIndex]: {
				fields: { [payload.fieldIndex]: { $set: payload.value } },
			},
		})
	}
}

export const addPage = (form, newPage, currentIndex, reference) => {
	const formCopy = form.map((item) => ({ ...item }))
	formCopy.splice(parseInt(currentIndex) + 1, 0, {
		...reference[0],
		...newPage,
	})

	return formCopy
}

export const addField = (form, payload) => {
	return form.map((page, index) => {
		if (index === payload.pageIndex) {
			return extend(page, {
				fields: [...page.fields, payload.newField],
				ids: [...page.ids, uuidv4()],
				valid: [...page.valid, true],
			})
		}
		return page
	})
}

export const removeField = (form, payload) => {
	return form.map((page, index) => {
		if (index === payload.pageIndex) {
			return extend(page, {
				fields: page.fields.filter(
					(field, index) => index !== payload.fieldIndex
				),
				ids: page.ids.filter((field, index) => index !== payload.fieldIndex),
				valid: page.valid.filter(
					(field, index) => index !== payload.fieldIndex
				),
			})
		}
		return page
	})
}

export const validField = (form, payload) => {
	return form.map((page, index) => {
		if (index === payload.pageIndex) {
			return extend(page, {
				valid: page.valid.map((value, index) =>
					index === payload.fieldIndex ? payload.value : value
				),
			})
		}
		return page
	})
}

export const selectStep = (workflow, payload) => {
	const { step, index } = payload
	const { steps } = workflow
	steps[index] = step
	return extend(workflow, { steps })
}

export const addStep = (workflow, payload) => {
	workflow = extend(workflow)
	workflow.steps.push(payload.newStep)
	if (workflow.steps.length > 1) {
		workflow.steps[workflow.steps.length - 2].next_step =
			workflow.steps.length - 1
	}
	return workflow
}

export const removeStep = (workflow, payload) => {
	workflow = extend(workflow)
	workflow.steps.splice(payload.index, 1)
	if (workflow.steps.length > 0 && payload.index > 0) {
		workflow.steps[workflow.steps.length - 1].next_step = null
	}
	return workflow
}

export const addVariable = (variables, payload) => {
	const newVariables = update(variables, {
		[payload.pageIndex]: { $push: [payload.newField.variable] },
	})
	return newVariables
}

export const removeVariable = (variables, payload) => {
	const newVariables = update(variables, {
		[payload.pageIndex]: { $splice: [[payload.fieldIndex, 1]] },
	})
	return newVariables
}

export const selectVariable = (variables, payload) => {
	if (payload.name === 'field') {
		const field = payload.value
		if (field.type !== 'separator') {
			let variable = getVariable(field)

			const newVariables = update(variables, {
				[payload.pageIndex]: { [payload.fieldIndex]: { $set: variable } },
			})
			return newVariables
		}
	}
	return variables
}

export const move = (data, payload) => {
	const moveArrayItem = (array, from, to) => {
		let tmpList = [...array]
		const item = array[from]
		tmpList.splice(from, 1)
		tmpList.splice(to, 0, item)
		return tmpList
	}
	switch (payload.name) {
		case 'form':
			return extend(data, {
				form: data.form.map((page, index) => {
					if (index === payload.listIndex) {
						return extend(page, {
							fields: moveArrayItem(page.fields, payload.from, payload.to),
							ids: moveArrayItem(page.ids, payload.from, payload.to),
							valid: moveArrayItem(page.valid, payload.from, payload.to),
						})
					}
					return page
				}),
				variables: data.variables.map((page, index) => {
					if (index === payload.listIndex) {
						return moveArrayItem(page, payload.from, payload.to)
					}
					return page
				}),
			})

		case 'workflow':
			let tmpList = data.workflow.nodes
			const dragged = tmpList[payload.from]
			tmpList.splice(payload.from, 1)
			tmpList.splice(payload.to, 0, dragged)

			tmpList.forEach((node, index) => {
				node.next_node = index === tmpList.length - 1 ? null : `${index + 1}`
			})

			return extend(data, {
				workflow: extend(data.workflow, {
					nodes: tmpList,
				}),
			})

		case 'signers':
			return extend(data, {
				signers: extend(data.signers, {
					signers: data.signers.signers.map((party, index) => {
						if (index === payload.listIndex) {
							return extend(party, {
								signers: moveArrayItem(party.signers, payload.from, payload.to),
							})
						}
						return party
					}),
				}),
			})

		case 'observers':
			return extend(data, {
				signers: extend(data.signers, {
					responsible_group: moveArrayItem(
						data.signers.responsible_group,
						payload.from,
						payload.to
					),
				}),
			})

		default:
			return data
	}
}

export const movePage = (form, payload) => {
	let tmpForm = form
	const dragged = tmpForm[payload.from]
	tmpForm.splice(payload.from, 1)
	tmpForm.splice(payload.to, 0, dragged)

	return tmpForm
}
